<template>
  <div>
    <b-modal id="modalEditSwitchTariffsetting" ref="modalEditSwitchTariffsetting"
      :title="$t('Switch tariff setting')" hide-footer>
      <div  v-if="editItem">
        <b-form-group label-align="right" v-if="editItem.id != 0" disabled label="ID :" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.id" disabled/>
        </b-form-group>
        <b-form-group label-align="right" :disabled="editItem.id != 0" :label="$t('Group')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="editItem.group_id" :options="groups" :disabled="editItem.id != 0"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Active')" label-cols="4" label-cols-xl="4" label-cols-md="4">
           <b-form-checkbox v-model="editItem.is_enabled" value="1" unchecked-value="0" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Instant change')" label-cols="4" label-cols-xl="4" label-cols-md="4">
           <b-form-checkbox v-model="editItem.instant_change" value="true" unchecked-value="false" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Instant change count')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.instant_change_count" />
        </b-form-group>
          <b-button size="sm" variant="success" style="float: right; width: 100px; margin-bottom:10px" @click="addElement">{{ $t('Add')}}</b-button>
        <basic-table
          :items="editItem.data"
          :fields="dataFields"
          @ClickOnEditButton="editTariff"
          @ClickOnDeleteButton="deleteTariff"
          isDelete="true"
          isEdit="true"/>
        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">{{ $t('Save')}}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalEditSwitchTariffsetting.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal id="modalEditSwitchTariffSettingElement" ref="modalEditSwitchTariffSettingElement"
      :title="$t('Tariff')" hide-footer>
      <div  v-if="editingElement">
        <b-form-group label-align="right" :label="$t('Tariff')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="tariffs.length > 0">
          <b-form-select v-model="editingElement.tariff_id" :options="newTariffs"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Min balance')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-row>
            <b-col>
              <b-form-input v-model="editingElement.min_balance" :disabled="editingElement.use_min_balance == 0" />
            </b-col>
              <b-form-checkbox v-model="editingElement.use_min_balance" value="1" unchecked-value="0" /> {{ this.$t('Use') }}
            <b-col>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Service')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="onceServices.length > 0">
          <b-form-select v-model="editingElement.service_id" :options="onceServices"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Free if balance more then')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-row>
            <b-col>
              <b-form-input v-model="editingElement.free_balance" :disabled="editingElement.use_free_balance == 0" />
            </b-col>
              <b-form-checkbox v-model="editingElement.use_free_balance" value="1" unchecked-value="0" /> {{ this.$t('Use') }}
            <b-col>
            </b-col>
          </b-row>
        </b-form-group>
        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="saveElement">{{ $t('Save')}}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalEditSwitchTariffSettingElement.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dataFields: [
        {key: 'tariff_id', label: this.$i18n.t('Tariff'), sortable: true, formatter: (val, key, item) => { for (let el of this.tariffs) if (el.value === val) return el.text }},
        {key: 'service_id', label: this.$i18n.t('Service'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      editingElement: null,
      tmpElementId: -1
    }
  },
  props: {
    editItem: null
  },
  methods: {
    saveElement () {
      let newArray = this.editItem.data.filter((item) => { return item.id !== this.editingElement.id })
      newArray.push(this.editingElement)
      this.editItem.data = newArray
      this.$refs.modalEditSwitchTariffSettingElement.hide()
    },
    save () {
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('Settings/UPDATE_SWITCH_TARIFFS', this.editItem)
        : this.$store.dispatch('Settings/CREATE_SWITCH_TARIFFS', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_SWITCH_TARIFFS')
          this.$refs.modalEditSwitchTariffsetting.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    editTariff (item) {
      this.editingElement = JSON.parse(JSON.stringify(item))
      this.$refs.modalEditSwitchTariffSettingElement.show()
    },
    addElement () {
      this.tmpElementId -= 1
      this.editingElement = {
        id: JSON.parse(JSON.stringify(this.tmpElementId)),
        tariff_id: 0,
        min_balance: 0,
        use_min_balance: 0,
        free_balance: 0,
        use_free_balance: 0,
        service_id: 0
      }
      this.$refs.modalEditSwitchTariffSettingElement.show()
    },
    deleteTariff (item) {
      this.editItem.data = this.editItem.data.filter((el) => { return el.tariff_id !== item.tariff_id })
    }
  },
  computed: {
    newTariffs () {
      let res = []
      for (let el of this.$store.getters['Tariffing/TARIFFS']) {
        if (el.id !== this.editingElement.tariff_id) {
          let isAlreadyHas = false
          for (let curEl of this.editItem.data) {
            if (el.id === curEl.tariff_id) {
              isAlreadyHas = true
              break
            }
          }
          if (isAlreadyHas) {
            continue
          }
        }
        let newEl = {}
        newEl.value = el.id
        newEl.text = el.name
        res.push(newEl)
      }
      return res
    },
    tariffs () {
      let res = []
      for (let el of this.$store.getters['Tariffing/TARIFFS']) {
        let newEl = {}
        newEl.value = el.id
        newEl.text = el.name
        res.push(newEl)
      }
      return res
    },
    onceServices () {
      let res = []
      for (let el of this.$store.getters['Tariffing/SERVICES']) {
        if (el.service_type !== 1) {
          continue
        }
        let newEl = {}
        newEl.value = el.service_id
        newEl.text = el.service_name
        res.push(newEl)
      }
      res.push({value: 0, text: this.$t('Empty')})
      return res
    },
    groups () {
      let res = []
      for (let el of this.$store.getters['Users/GROUPS']) {
        let newEl = {}
        newEl.value = el.group_id
        newEl.text = el.group_name
        res.push(newEl)
      }
      res.push({value: 0, text: this.$t('All')})
      return res
    }
  },
  mounted () {
    this.$store.dispatch('Tariffing/GET_TARIFFS')
    this.$store.dispatch('Tariffing/GET_SERVICES')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/customerPortal/switchTariff/editModal.vue